<template>
  <div>
    <div class="titleTopic" v-if="title">{{title}}</div>
    <v-layout class="row wrap" v-if="subtitle">
      <div class="subtitle-text">{{subtitle}}</div>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" small class="cursor: pointer" @click="copyURL(topic_path)">content_copy</v-icon>
        </template>
        <span>Copy link to this section</span>
      </v-tooltip>
    </v-layout>
    <div class="single-paragraph" v-if="paragraph">{{paragraph}}</div>
    <div class="multi-paragraph" v-if="paragraphs" v-for="paragraph in paragraphs"><p>{{paragraph}}</p></div>
    <a v-if="hyperlink" :href="hyperlink.linkPath" target="_blank" rel="noopener noreferrer">
      {{hyperlink.linkText}}
    </a>
    <v-snackbar v-model="display_feedback" :timeout="2000" bottom>Link copied to the clipboard</v-snackbar>
    <div class="important-container" v-if="important">
      <div class="important-title"  v-if="important">
        Important
      </div>
      <ul v-if="important.constructor.name == 'Array'">
        <li v-for="importantNote in important">
          {{importantNote}}
        </li>
      </ul>
      <p v-if="important.constructor.name == 'String'">
        {{important}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    paragraph: String,
    important: Array,
    paragraphs: Array,
    hyperlink: Object,
    topic_path: String
  },
  data () {
    return {
      display_feedback: false
    }
  },
  methods: {
    copyURL(path) {
      if (window.navigator.clipboard) {
        this.display_feedback = true
        window.navigator.clipboard.writeText(`${window.location.origin}/#/docs/section/${path}`)
      }
    },
  }
}

</script>

<style>
.titleTopic {
  font-family: 'Paralucent';
  font-size: 36px;
  letter-spacing: 1px;
  padding: 1% 0px 0px;
}

.subtitle-text {
  font-family: 'Paralucent';
  letter-spacing: 1px;
  font-size: 18px;
  padding: 5px 0px;
}

.single-paragraph {
  font-family: 'Paralucent';
  font-size: 14px;
  letter-spacing: 0.5px;
  padding: 0px 0px 20px;
}

.important-container{
  font-family: 'Paralucent';
  font-size: 14px;
  letter-spacing: 1px;
  padding: 10px;
  border: solid  5px;
  border: solid limegreen 5px;
  margin: 10px 0px;
}

.important-title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
}

.multi-paragraph {
  letter-spacing: 0.5px;
  padding: 0px 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/TitleSection.vue